import { api } from "./api";

const supplierApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSuppliers: builder.query({
      query: () => "suppliers",
      providesTags: ["suppliers"],
    }),
    addSupplier: builder.mutation({
      query: (newCategory) => ({
        url: "suppliers",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["suppliers"],
    }),
    removeSupplier: builder.mutation({
      query: (id) => ({
        url: `suppliers/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["suppliers"],
    }),
    editSupplier: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/suppliers/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["suppliers"],
    }),
  }),
});

export const {
  useGetSuppliersQuery,
  useAddSupplierMutation,
  useRemoveSupplierMutation,
  useEditSupplierMutation,
} = supplierApi;
